var map = {
	"./body/B/B1.png": "8427",
	"./body/B/B10.png": "d5d9",
	"./body/B/B11.png": "f8ff",
	"./body/B/B2.png": "8f3e",
	"./body/B/B3.png": "b251",
	"./body/B/B4.png": "77d6",
	"./body/B/B5.png": "fd00",
	"./body/B/B6.png": "f4ec",
	"./body/B/B7.png": "fbd1",
	"./body/B/B8.png": "7f4a",
	"./body/B/B9.png": "cd80",
	"./body/C/Ca.png": "014c",
	"./body/C/Cb.png": "eb5a",
	"./body/C/Cc.png": "4288",
	"./body/C/Cd.png": "7d48",
	"./body/C/Ce.png": "99fe",
	"./body/D/Da.png": "1e7f",
	"./body/D/Db.png": "52d1",
	"./body/D/Dc.png": "473c",
	"./body/E/Ea.png": "db5b",
	"./body/E/Eb.png": "1829",
	"./body/E/Ec.png": "3d73",
	"./body/E/Ed.png": "e137",
	"./body/E/Ee.png": "69d9",
	"./body/E/Ef.png": "cb82",
	"./body/F/Fa.png": "5ae9",
	"./body/F/Fb.png": "a5c0",
	"./body/F/Fc.png": "0c67",
	"./body/G/Ga.png": "e9da",
	"./body/G/Gb.png": "d4b9",
	"./body/G/Gc.png": "8a43",
	"./body/G/Gd.png": "a155",
	"./body/H/Ha.png": "5975",
	"./body/H/Hb.png": "e168",
	"./body/H/Hc.png": "9ee9",
	"./body/I/Ia.png": "9037",
	"./body/I/Ib.png": "571d",
	"./body/I/Ic.png": "fe1f",
	"./body/J/Ja.png": "3236",
	"./body/J/Jb.png": "ed08",
	"./body/J/Jc.png": "32fe",
	"./body/J/Jd.png": "7f7c",
	"./body/K/Ka.png": "3851",
	"./body/K/Kb.png": "1c4e",
	"./body/K/Kc.png": "742a",
	"./body/K/Kd.png": "9b1e",
	"./body/K/Ke.png": "e953",
	"./body/K/Kf.png": "fd85",
	"./body/K/Kg.png": "4259",
	"./body/K/Kh.png": "584d",
	"./body/K/Ki.png": "7e25",
	"./body/K/Kj.png": "040a",
	"./body/K/Kk.png": "24f0",
	"./body/L/La.png": "1451",
	"./body/L/Lb.png": "6317",
	"./body/L/Lc.png": "2d75",
	"./body/L/Ld.png": "5086",
	"./body/M/Ma.png": "378f",
	"./body/M/Mb.png": "eaf2",
	"./body/M/Mc.png": "7e8f",
	"./skirt/B/B1.png": "20c1",
	"./skirt/B/B10.png": "8c9e",
	"./skirt/B/B2.png": "5d78",
	"./skirt/B/B3.png": "c3cf",
	"./skirt/B/B4.png": "5038",
	"./skirt/B/B5.png": "b7ec",
	"./skirt/B/B6.png": "2b0c",
	"./skirt/B/B7.png": "7f1e",
	"./skirt/B/B8.png": "9f6d4",
	"./skirt/B/B9.png": "00fb",
	"./skirt/C/Ca.png": "9bcb",
	"./skirt/C/Cb.png": "0faf",
	"./skirt/C/Cc.png": "cff6",
	"./skirt/D/Da.png": "0efb",
	"./skirt/D/Db.png": "883f",
	"./skirt/F/Fa.png": "faec8",
	"./skirt/F/Fb.png": "f2f7",
	"./skirt/F/Fc.png": "6dd2",
	"./skirt/G/Ga.png": "c914",
	"./skirt/G/Gb.png": "d2a0",
	"./skirt/G/Gc.png": "4c194",
	"./skirt/G/Gd.png": "99c0",
	"./skirt/H/Ha.png": "e6df",
	"./skirt/H/Hb.png": "ea0d",
	"./skirt/H/Hc.png": "ece4",
	"./skirt/I/Ia.png": "0a74",
	"./skirt/I/Ib.png": "a85b",
	"./skirt/I/Ic.png": "4699",
	"./skirt/I/Id.png": "210b",
	"./skirt/J/Ja.png": "ccb2",
	"./skirt/J/Jb.png": "4312",
	"./skirt/K/Ka.png": "04ab",
	"./skirt/K/Kb.png": "2617",
	"./skirt/K/Kc.png": "1ffe",
	"./skirt/K/Kd.png": "b5a3",
	"./skirt/L/La.png": "2409",
	"./skirt/L/Lb.png": "ea34",
	"./skirt/L/Lc.png": "5583",
	"./skirt/M/Ma.png": "7210",
	"./skirt/M/Mb.png": "0c17",
	"./skirt/M/Mc.png": "5d74"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e78";